'use client'

import { useEffect } from 'react'
import SearchResults from '@/components/assets-explorer/search-results'

export const runtime = 'edge'

export default function Page() {
  useEffect(() => {
    console.debug(`DEBUG > Search page loaded `)
  }, [])

  return <SearchResults />
}
